export default __webpack_public_path__ + "static/media/SWT0190.34I-27412_-16474_0.cd43dd17.jpg";